<template>
  <div class="home">
    <div class="flex-grid" v-if="currentUser.id">
      <div class="grid-title">
        <h1>Administrar datos de empresa</h1>
      </div>
      <vs-tabs class="we-tabs entity" ref="tabs">
        <vs-tab label="Datos de la entidad">
          <EntitySettingsTab />
        </vs-tab>
        <vs-tab label="Establecimientos compradores" v-if="currentUser.canBuy">
          <BuyerEstablishmentsTab rol="buyer" :roles="roles" @reload-establishments="reloadEstablishments()" @get-establishments="getEstablishments()"></BuyerEstablishmentsTab>
        </vs-tab>
        <vs-tab label="Establecimientos vendedores" v-if="currentUser.canSell">
          <SellerEstablishTab rol="seller" :roles="roles" @reload-establishments="reloadEstablishments()" @get-establishments="getEstablishments()"></SellerEstablishTab>
        </vs-tab>
        <vs-tab label="Usuarios">
          <UserTab @reloadEstab="getEstablishments"></UserTab>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import EntitySettingsTab from '../components/organizationSettings/EntityTab'
import BuyerEstablishmentsTab from '../components/organizationSettings/BuyerEstablishmentsTab'
import UserTab from '../components/organizationSettings/UserTab'
import SellerEstablishTab from '../components/organizationSettings/SellerEstablishTab'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

const organizationDetail = gql`
  query organizationDetail($currentUserToken: String, $organizationId: Int){  
    organizationDetail(currentUserToken: $currentUserToken, organizationId: $organizationId){
      businessName
      city
      comments
      commercialAddress
      country
      cuit
      email
      id
      establishments {
        active
        activity
        city
        cuig
        id
        marketRole
        name
        number
        renspa
        ruca
        state
        zipcode
        users {
          canBuy
          canSell
          createdAt
          cuil
          currentTime
          dni
          email
          establishmentRole
          firstname
          id
          lastname
          offerRole
          organizationId
          passport
          phone
        }
      }
      ivaSituation
      logo
      mainActivity
      ruca
      slaughterQuantityPerMonth
      productionMothers
      phone
      state
      users {
        createdAt
        email
        firstname
        id
        lastname
        offerRole
        establishmentRole
        organization {
          businessName
        }
      }
      zipcode
    }
  }
`

const fetchRoles = gql`
  query fetchRoles($names: [String!]) {
    fetchRoles(names: $names) {
      id
      name
    }
  }
`

export default {
  name: 'organization-settings',
  components: {
    EntitySettingsTab,
    BuyerEstablishmentsTab,
    UserTab,
    SellerEstablishTab
  },
  data () {
    return {
      roles: []
    }
  },
  beforeMount() {
    if (this.currentUser) {
      this.getEstablishments()
      this.fetchRoles()
    }
  },
  watch: {
    currentUser () {
      this.getEstablishments()
      this.fetchRoles()
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser,
      establishments: state => state.SignUp.establishments
    })
  },
  methods: {
    ...mapMutations('SignUp', [
      'pushEstablishment',
      'removeEstablishment',
      'toggleStatusEstablishment',
      'updateEstablishment',
      'clearEstablishments'
    ]),
    reloadEstablishments () {
      this.clearEstablishments()
      this.getEstablishments()
    },
    getEstablishments (){
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(organizationDetail),
        variables: {
          organizationId: this.currentUser.organizationId
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.clearEstablishments()
          res.data.data.organizationDetail.establishments.forEach(est => {
            if(!this.establishments[est.marketRole].find(e => e.id === est.id)) {
              this.pushEstablishment({ rol: est.marketRole, value: est}) 
            }
          })
        }else {
          console.log(res.data.errors)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchRoles() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchRoles),
        variables: {
          names: []
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.roles = res.data.data.fetchRoles
        }else{
          console.log(res.data.errors)
        }
      }).catch(err =>{
        console.log(err)
      })
    }
  }
}
</script>
